import styled from "styled-components";
import { Heading } from "../../atoms/Typography/Typography.component";
import Shape from "../../atoms/Shape/Shape.component";

export const ErrorPage = styled.div`
  position: relative;
  overflow-x: hidden;
`;

export const ErrorPageContainer = styled.div`
  padding-top: ${({ theme }) => theme.rem(40)};
  padding-bottom: ${({ theme }) => theme.rem(40)};
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: ${({ theme }) => theme.rem(55)};
  justify-content: center;
  align-items: center;
  min-height: 70vh;

  ${({ theme }) =>
    theme.mediaQuery.lg(`
  padding-top: ${theme.rem(60)};
  padding-bottom: ${theme.rem(60)};
`)}
`;

export const ErrorPageContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${({ theme }) => theme.rem(46)};
`;

export const ImageContainer = styled.div`
  // max-width: 800px;
`;

export const StyledLeafShape = styled(Shape)`
  position: absolute;
  bottom: 10px;
  right: -130px;
  width: ${({ theme }) => theme.rem(276)};
  height: ${({ theme }) => theme.rem(138)};
  z-index: -1;

  ${({ theme }) =>
    theme.mediaQuery.lg(`
  right: -208px;
  width: ${theme.rem(416)};
  height: ${theme.rem(208)};
`)}
`;

export const StyledCircleShape = styled(Shape)`
  position: absolute;
  top: 50px;
  left: -80px;
  width: ${({ theme }) => theme.rem(214)};
  height: ${({ theme }) => theme.rem(214)};
  z-index: -1;

  ${({ theme }) =>
    theme.mediaQuery.lg(`
  width: ${theme.rem(270)};
  height: ${theme.rem(270)};
  left: -100px;
`)}
`;

export const StyledHeading = styled(Heading)`
  color: #19345e;
`;

export const ErrorPageCTA = styled.div``;

export const GreenLeaf = styled.img`
  position: absolute;
  bottom: -90px;
  left: 50%;
  transform: translateX(-50%) rotate(15deg);
  width: 180px;
  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(100deg)
    brightness(118%) contrast(119%);
  opacity: 0.6;
  z-index: -1;
`;
